import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import {
  type ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  type Provider,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  Router,
  withComponentInputBinding,
  withViewTransitions,
} from '@angular/router';
import {
  createErrorHandler as SentryCreateErrorHandler,
  TraceService as SentryTraceService,
} from '@sentry/angular';

import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { routes } from './app.routes';
import { AuthApi } from './auth/auth-api';
import { authInterceptor } from './auth/auth.interceptor';
import { PusherClient } from './_shared/pusher';

export const EXACT_DATE_PIPE_PROVIDER: Provider[] = [
  { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { timezone: 'UTC' } },
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withViewTransitions(), withComponentInputBinding()),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideAppInitializer(() => {
      inject(AuthApi).initializeAuth();
      inject(PusherClient).initPusher();
    }),
    provideEnvironmentNgxMask(),
    EXACT_DATE_PIPE_PROVIDER,
    [
      {
        provide: ErrorHandler,
        useValue: SentryCreateErrorHandler({
          showDialog: false,
        }),
      },
      {
        provide: SentryTraceService,
        deps: [Router],
      },
    ],
  ],
};
